module.exports = __webpack_public_path__ + "img/hr-puberty-decal-17.7089a77d.png";